import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';

export interface DialogData {
  balance: number;
}

@Component({
  selector: 'app-confirm-enable-screen-negative-payment',
  templateUrl: './confirm-enable-screen-negative-payment.component.html',
  styleUrls: ['./confirm-enable-screen-negative-payment.component.scss']
})
export class ConfirmEnableScreenNegativePaymentComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) { 
    
  }

  ngOnInit(): void {
    
  }

}
